var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraphic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2000,
    height: 1009.54,
    viewBox: "0 0 2000 1009.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".c{fill:none;stroke:#1d1d1b;stroke-miterlimit:10;stroke-width:1px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M336.99,296.53c25.46,81.61-43,49.88-48.79,82.65-26.86,151.87,38.99,388.9-1.16,557.62l74.24,47.53H118.71s74.37-48.06,74.37-48.06c-5.68-89.27,27.5-162.07-50.53-186.26,65.02-12.17,61.62-301.08,49.23-370.84-5.82-32.79-74.23-1.03-48.79-82.65h194Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M124.8,295.74v516.21c0,6.29,37.02,35.21,24.05,78.19-6.74,10.22-48.33-40.01-48.33-46.91V327.02h-48.56v531.86h-24.28V295.74h97.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M450.16,295.74v547.5c0,6.89-41.59,57.13-48.33,46.91-12.97-42.98,24.05-71.9,24.05-78.19v-484.93h-48.56v500.57h-24.28V295.74h97.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M165.92,278.94h-48.67l-2.44-201.35c-.87,4.56-2.14,11.04-3.83,19.45-1.68,8.41-3.07,14.95-4.15,19.61l-34.35,162.29H25.78L76.72,39.01h72.92l3.42,188.66L236.57,39.01h72.11l-50.95,239.93h-46.72l34.35-162.29c1.09-4.66,2.58-11.2,4.48-19.61,1.9-8.41,3.28-14.89,4.15-19.45l-88.06,201.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M496.68,235.8l-9.12,43.14h-181.82l50.95-239.93h175.96l-9.12,42.48h-126.96l-10.74,50.95h116.55l-8.95,41.67h-116.55l-13.02,61.69h132.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M579.53,236.61h125.82l-8.95,42.32h-186.7l8.95-42.32,156.75-155.12h-120.78l9.12-42.48h183.28l-8.63,40.21-158.87,157.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M783.17,236.61h125.82l-8.95,42.32h-186.7l8.95-42.32,156.75-155.12h-120.78l9.12-42.48h183.28l-8.63,40.21-158.87,157.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1110.18,39.01l34.02,239.93h-54.37l-5.05-49.32h-88.39l-27.02,49.32h-52.41l136.57-239.93h56.65ZM1069.65,93.86l-50.95,94.41h60.88l-9.93-94.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1318.53,278.94l-61.85-170.42-36.14,170.42h-46.72l50.95-239.93h52.58l59.9,167.49,35.65-167.49h46.72l-50.95,239.93h-50.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1411.48,278.94l50.95-239.93h49.81l-50.95,239.93h-49.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1651.89,278.94l-61.85-170.42-36.14,170.42h-46.72l50.95-239.93h52.58l59.9,167.49,35.65-167.49h46.72l-50.95,239.93h-50.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1941.14,235.8l-9.12,43.14h-181.82l50.95-239.93h175.96l-9.12,42.48h-126.96l-10.74,50.95h116.55l-8.95,41.67h-116.55l-13.02,61.69h132.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1821.88,296.95c25.46,81.61-43,49.88-48.79,82.65-26.86,151.87,38.99,388.9-1.16,557.62l74.24,47.53h-242.57s74.37-48.06,74.37-48.06c-5.68-89.27,27.5-162.07-50.53-186.26,65.02-12.17,61.62-301.08,49.23-370.84-5.82-32.79-74.23-1.03-48.79-82.65h194Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1609.69,296.15v516.21c0,6.29,37.02,35.21,24.05,78.19-6.74,10.22-48.33-40.01-48.33-46.91V327.44h-48.56v531.86h-24.28V296.15h97.12Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1935.05,296.15v547.5c0,6.89-41.59,57.13-48.33,46.91-12.97-42.98,24.05-71.9,24.05-78.19v-484.93h-48.56v500.57h-24.28V296.15h97.12Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphic);
export default __webpack_public_path__ + "static/media/graphic.bf928eca2ab1dec569f467f7ba83515d.svg";
export { ForwardRef as ReactComponent };